<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" (keydown.enter)="getAttendenceFilter(searchVal)" placeholder="Search By Name" #name
                        [(ngModel)]="searchVal" />
                      <button class="btn search-btn glow position-absolute" (click)="getAttendenceFilter(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                    </div>
                  </div>
                  
                </div>
                <div class="col-12">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="40"
                    rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true" [count]="page.totalPages"
                    [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
                  <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Student Attendance Guideline</button>
                  </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Title" prop="title">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <div class="cell-line-height">
                      <p class="font-medium-1 line-height-1 mb-0">
                        {{ row.title }}
                      </p>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Time" prop="start_time">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span>{{row?.classId[0]?.start_time}} - {{row?.classId[0]?.end_time}}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Date" prop="date">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.date | date:'mediumDate'}}
                </ng-template>
              </ngx-datatable-column>
            <ngx-datatable-column name="Students" prop="students">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="cursor-pointer" (click)="openModalStudents(studentsModal,row?.classId)">{{row?.student_id[0]?.name}}</span>
              </ng-template>
            </ngx-datatable-column>
              
              <ngx-datatable-column name="Course" prop="course_id">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.course_id[0]?.title}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Attendance" prop="stu_attendance">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span class="d-flex"><i class="ft-check text-info" *ngIf="row?.start_teacher == true"></i>
                    <!-- Icon for 'present' status -->
<i *ngIf="row?.attendance_status === 'present'" class="ft-check text-success"></i>
<!-- Icon for 'absent' status -->
<i *ngIf="row?.attendance_status === 'absent'" class="ft-check text-danger"></i>
</span>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

<!-------- Students ---------- -->
<div>
  <ng-template #studentsModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{students_list[0].students?.student_id[0]?.name}} Topic List</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
         
          <table border="1" style="width: 1100px;">
            <tr>
              <th>Topic</th>
              <th>Action</th>
            </tr>
            <tr *ngFor="let item of students_list">
              <td>
                <span *ngFor="let topic of item.students.topic_id; last as isLast">
                  <span>{{topic.name}}</span>
                  <span *ngIf="!last">,</span>
                </span>
              </td>
              <td id="action">
                <button class="btn btn-sm btn-primary mx-2 my-1" (click)="checkPendingTopics(pendingTopicsModal,item?.students?.student_id[0]?._id,item?.students?.course_id[0]?._id)">Check Pending Topics</button>
              </td>
            </tr>
          </table>
        </div>
      </form>
    </div>
  </ng-template>
</div>
<!-------- Topics ---------- -->
<div>
  <ng-template #topicsModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Topics List</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
     
        <div>
          <table border="1" style="width: 765px;">
            <tr>
              <th>Topic</th>
            </tr>
            <tr *ngFor="let topic of topics_list;let i=index">
              <td>{{topic?.name}}</td>
            </tr>
          </table>
        </div>
    </div>
  </ng-template>
</div>
<div>
  <ng-template #pendingTopicsModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Pending Topics List</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
     
      <div>
        <table border="1" style="width: 765px;">
          <tr>
            <th>Topic</th>
          </tr>
          <tr *ngFor="let topic of pending_student_topics;let i=index">
            <td>{{i + 1}}</td>
            <td>{{topic?.topic_name}}</td>
          </tr>
        </table>
      </div>
    </div>
  </ng-template>
</div>